import type { SubOfferState } from './types';

const initialState: SubOfferState = {
  expiresAt: 0,
  notificationShown: false,
  viewedAt: 0,
};

export default initialState;
